import {withRouter} from 'react-router';
import {get as _get, has as _has} from 'lodash';

import {withApollo} from 'react-apollo';
import EventForm from '@modules/events/forms/EventForm';
import {
    dataToSave,
    setPropertyLicenceFieldOptions,
    setStageCommonFields,
    loadStageDataHelper,
    resetStageDateTimeFields,
} from '@modules/events/forms/ExistingStageEvent/stageFormHelper';
import {convertToInt} from '@utils/helpers';
import {getLink} from '@appComponents/Link';
import {refetchQueryByName} from '@utils/apollo';
import {updateClipProvidersFieldBasedOnPreset} from '@modules/events/utils/formHelper';

class ExistingStageEventEditForm extends EventForm {
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);

        const {property_licence, stage_category_id, event_preset} = this.props.formValues;
        const prevStEvent = prevProps?.GraphQLEntityData?.event?.st_event;
        const currStEvent = _get(this.props, 'GraphQLEntityData.event.st_event', null);

        setPropertyLicenceFieldOptions(this, prevProps, prevState);

        if (property_licence && stage_category_id) {
            this.setCoverageField(prevProps, null, null, false, false, stage_category_id);
            this.toggleClipProvidersDropdown(prevProps, prevState);
        }

        if (currStEvent && currStEvent !== prevStEvent) {
            this.applyStageEventData(currStEvent);
        }

        if (property_licence && property_licence !== prevProps.formValues.property_licence) {
            this.updateRightsScopesDatesRange(property_licence);
            this.getPresetsForPropertyLicence(property_licence, this.props.formParams.id);
        }

        if (event_preset && !_get(this.state, 'defaultForm_fields.coverage.props.hidden', false)) {
            updateClipProvidersFieldBasedOnPreset(
                this.props, prevProps.formValues, this.setField, this.state, this.state.presetsListObject
            );
        }
    }

    async applyStageEventData(currStEvent) {
        const hasStage = _has(currStEvent, 'stage.id');
        const data = hasStage ? currStEvent.stage : {...currStEvent};

        this.setField('stage_category_id', {
            defaultValue: data.stage_category.id,
        });

        this.setField('stage_name', {
            defaultValue: data.name,
        });

        await setStageCommonFields(this.setField, data);

        this.setField('synchronise_times', {
            defaultValue: currStEvent.synchronise_times,
        });

        this.setField(['start_datetime', 'end_datetime'], {
            disabled: currStEvent.synchronise_times,
        });
    }

    prepareDataForSubmit(data) {
        const result = dataToSave(this, data);
        result.id = convertToInt(data.id);

        return result;
    }

    componentDidMount() {
        super.componentDidMount();

        this.setDeleteSuccessCallback(() => {
            this.props.history.push(getLink('events.index'));
        });

        this.setUpdateSuccessCallback(() => {
            refetchQueryByName('EventQuery');
            this.backToEventPage();
        });

        this.setUpdateErrorCallback(() => {
            this.props.Modal.setModal({isVisible: false});
        });

        this.setOnChangeCallback({
            'synchronise_times': (data) => {
                this.setField(['start_datetime', 'end_datetime'], {
                    disabled: !data.value,
                });

                if (!data.value) {
                    resetStageDateTimeFields(this.setField, this.state.stageData);
                }
            },
        });

        loadStageDataHelper(this);
    }

    renderSaveButton = () => {
        return super.renderSaveButton({
            content: 'Save',
        });
    };
}

export default withRouter(withApollo(ExistingStageEventEditForm));
